export default __webpack_public_path__ + "static/media/fad-vsquareswitch-on.2f808995.svg";